module.exports = __webpack_public_path__ + "img/prioritas_sameday_dfod.e16f1f57.png";